/** @jsx jsx */
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import { Fragment } from "react"
import { jsx } from "theme-ui"

import Border from "@components/Border"
import Hero from "@components/Hero"
import Variant from "@components/Variant"

export const fragment = graphql`
  fragment ContentfulHeroBlock on ContentfulHeroBlock {
    body {
      body
    }
    roundedImage
    ctaLinks {
      href
      id
      slug
      title
    }
    heading {
      heading
    }
    id
    media {
      ...Media
    }
    simpleList: list {
      id
      items {
        id
        text
      }
    }
  }
`

export default function HeroBlock({
  body,
  ctaLinks,
  heading,
  media,
  simpleList,
  roundedImage,
}) {
  return (
    <Fragment>
      <Variant as="section" variants={["sectionContainer"]}>
        <Variant
          as="div"
          d="flex"
          sx={{
            alignItems: "center",
            flexDirection: "column",
          }}
          variants={["container", "containerSpacingX"]}
        >
          <Hero
            ctaLinks={ctaLinks}
            list={simpleList?.items}
            media={media}
            text={body?.body}
            title={heading?.heading}
            roundedImage={roundedImage && roundedImage}
          />
        </Variant>
      </Variant>
      <Border />
    </Fragment>
  )
}

HeroBlock.typeName = "ContentfulHeroBlock"

HeroBlock.defaultProps = {
  body: null,
  ctaLinks: null,
  simpleList: null,
}

HeroBlock.propTypes = {
  body: PropTypes.shape({
    body: PropTypes.string.isRequired,
  }),
  ctaLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      slug: PropTypes.string,
      title: PropTypes.string.isRequired,
    })
  ),
  heading: PropTypes.shape({
    heading: PropTypes.string.isRequired,
  }).isRequired,
  media: PropTypes.object.isRequired,
  node_locale: PropTypes.string.isRequired,
  simpleList: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }),
}
